/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('shopAuth').service('mnpNbaProvider', [ '$state', '$http', '$injector', '$q', 'mnploginProvider', 'mnpCookieService', function($state, $http, $injector, $q, mnploginProvider, mnpCookieService) {

        var config = $injector.get('config');

        function isUserLogged() {
            return 'undefined' !== typeof window.portingUser && null !== window.portingUser;
        };

        /*
         * checks for a valid session on every user action and restarts the session timeout
         */
        function checkSession() {
            var deferred = $q.defer();

            // no userdata found -> login
            if (!isUserLogged()) {
                removeUsersession();
                deferred.reject('No Userdata found');
            } else {
                nba().then(function(response) {
                    var cookie = mnpCookieService.get();
                    if (!cookie.MSISDN) {
                        // no msisdn selected, show contractchooser
                        deferred.reject('No MSISDN selected');
                        trackingSrv.trackError('', trackingSrv.E_TYPE_NOTIFICATION, 'No MSISDN selected', $state.current.url);

                        startSessionTimer();
                        showContractChooser();

                    } else if (cookie.MSISDN === window.portingUser.MSISDN && cookie.MSISDN === response.data.MSISDN) {
                        // user is logged in and has MSISDN selected and not changed
                        startSessionTimer();// start/restart 30 min timeout
                        deferred.resolve(response);

                    } else {
                        // Kick Out
                        deferred.reject('MSISDN changed');
                        trackingSrv.trackError('', trackingSrv.E_TYPE_TECHNICAL, 'MSISDN changed due running session', $state.current.url);
                        logout();
                    }

                }, function(response) {
                    // userdata found, but BE session lost -> re-login
                	trackingSrv.trackError('', trackingSrv.E_TYPE_TECHNICAL, 'session timeout', $state.current.url);
                    removeUsersession();
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        };

        function showContractChooser() {
            // TODO: implement contractChooser and replace following workaround
            contractChooserWorkaround();
        }

        /**
         * TODO: for now just a workaround until final contractchooser is implememted. user will be logged out and will be requested to login with msisdn
         */
        function contractChooserWorkaround() {
            mnploginProvider.logoutAll().finally(function() {
                removeUsersession(true, 'contractChooser');

                // change login status in MDD
                vf.glnav.updateLoginIndicator();
            });
        }

        function nba() {
            var response = $http({
                method: 'GET',
                url: config.apiURLs.NBA
            });
            return response;
        };

        /**
         * start or restart the 30 minutes timeout
         */
        function startSessionTimer() {
            clearSessionTimer();
            window.portingSessionTimer = window.setTimeout(function() {
                logout();
            }, (30.5 * 60 * 1000));
        }

        function clearSessionTimer() {
            if (window.portingSessionTimer) {
                clearTimeout(window.portingSessionTimer);
                window.portingSessionTimer = null;
            }
        }

        /**
         * logout from myFv and bShop finally remove userdata and goto home and re-check for logged user
         */
        function logout() {
            return mnploginProvider.logoutAll().finally(function() {
                removeUsersession();
                // explicite reload here
                window.location.reload(true);
            });
        }

        /**
         * remove the apps userdata and per default redirect to home page, if not disabled via param redirectHome
         */
        function removeUsersession(redirect, redirectTo) {
            redirect = (false === redirect) ? false : true; // explicit false to disable
            redirectTo = redirectTo || 'home';// default
            clearSessionTimer();
            window.portingUser = null;
            mnpCookieService.kill();
            if (redirect) {
                $state.go(redirectTo);
            }
        }

        return {
            isUserLogged: isUserLogged,
            checkSession: checkSession,
            showContractChooser: showContractChooser,
            nba: nba,
            startSessionTimer: startSessionTimer,
            clearSessionTimer: clearSessionTimer,
            logout: logout
        };
    }
    ]);
}());
